<template>
  <div class="LmLoading" :style="{width: size + 'px', height: size + 'px'}">
    <svg viewBox="0 0 100 100">
      <circle
        class="Circle"
        cx="50"
        cy="50"
        r="42"
        :stroke="blue ? '#6495ed' : color"
        stroke-width="8"
        stroke-dasharray="220"
        stroke-dashoffset="30"
        transform="rotate(0)"
      ></circle>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'LmLoading',
  props: {
    size: {
      type: Number,
      default: 24
    },
    color: {
      type: String,
      default: '#171717'
    },
    blue: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
.LmLoading {
  .Circle {
    fill: none;
    transform-origin: center center;
    animation: rotate 1s infinite linear;
  }
}
</style>
